import { z } from 'zod'

import { messages } from '@/lib/messages'
import type { CashPaymentTransition } from '@/services/http/cash'

const t = messages.cash.paymentList

/** Ödeme listesini geri gönderme notu; sınır backend `CashPaymentTransition.note` ile aynı. */
export const sendBackSchema = z.object({
  note: z.string().trim().min(1, t.noteRequired).max(1000, t.noteTooLong),
})

export type SendBackValues = z.infer<typeof sendBackSchema>

export function sendBackBody(firm: string, weekEnd: string, values: SendBackValues) {
  return {
    firm,
    week_end: weekEnd,
    target: 'taslak',
    note: values.note.trim(),
  } satisfies CashPaymentTransition
}
